import React from "react"
import styles from "./notificationDisciplines.module.css"

/**
 * Lista as disciplinas sem data de início/término carregadas no payload da notificação
 * (data.disciplines — rótulo "Nome (ID)"). Compartilhado pelo sino (notificationBell) e pela tela
 * de notificações. Renderiza nada quando não há disciplinas no payload.
 */
export default function NotificationDisciplines({ disciplines }) {
  if (!Array.isArray(disciplines) || disciplines.length === 0) {
    return null
  }

  return (
    <div className={styles.box}>
      <p className={styles.title}>
        Disciplinas sem data ({disciplines.length})
      </p>
      <ul className={styles.list}>
        {disciplines.map((d, idx) => (
          <li key={idx} className={styles.item}>{d}</li>
        ))}
      </ul>
    </div>
  )
}
